import { taskMarkerStyle } from "helpers/map";
import React from "react";
import { CircleMarker } from "react-leaflet";

export default function RouteEventPoint({ routeEvent }) {
    if (!routeEvent) {
        return null;
    }

    const { location } = routeEvent;
    const loc = [location[1], location[0]];

    return <CircleMarker center={loc} {...taskMarkerStyle} pane="markerPane" />;
}
